import type {ReactNode} from "react";
import {useChecklistData} from "../ChecklistDataContext";
import {CheckStatusButtons} from "../CheckStatusButtons";
import {CommentButton} from "../CommentButton";
import type {Status} from "../../types";
import styles from "../checklist.module.css";

const pruneTitle = (title: string | undefined): string => {
    if (!title) return "";
    return title.replace("[Infopunkt]", "").replace("[Uten tittel]", "").trim();
};

export const CheckItemLeafNode = ({
    children,
    itemId,
    names,
}: {
    children: ReactNode;
    itemId: string;
    names: Record<Status, string>;
}) => {
    const {viewFilteredToc, collectionData, onCheckItemStatusClick, infoIdSet} =
        useChecklistData();

    const node = viewFilteredToc[itemId];
    if (!node) return null;

    const isInfoNode = infoIdSet.has(itemId) || node.info === true;
    const prunedTitle = pruneTitle(node.title);

    return (
        <div
            className={`${styles.checkItemLeafNode} ${isInfoNode ? styles.checkItemInfo : ""}`}
        >
            <div className={styles.checkItemLeafNodeContent}>
                {prunedTitle && (
                    <header>
                        <h4 data-searchable="true">{prunedTitle}</h4>
                        {!isInfoNode && collectionData && (
                            <CommentButton variant="icon" nodeId={itemId} />
                        )}
                    </header>
                )}
                {children}
            </div>
            {!isInfoNode && (
                <div>
                    <CheckStatusButtons
                        itemId={itemId}
                        onStatusClick={(s) =>
                            onCheckItemStatusClick({id: itemId, status: s})
                        }
                        names={names}
                    />
                </div>
            )}
        </div>
    );
};
